/* eslint-disable */ import { assertString, detailComponent, entityHeaderComponent, materialSwatchComponent, memoEval, sceneEntitySelectHotspotComponent, staticPerspectiveCameraComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const drawstringComponents = [
    attachComponent.withComponent(staticPerspectiveCameraComponent, 'default', true).withEntity('Drawstring').withGradualFilter({
        selectedEntityIds: (self)=>self.id,
        viewStates: [
            'Default'
        ]
    }).attach(memoEval(()=>[], ()=>({
            priority: 2,
            fov: 35,
            near: 50,
            far: 2000,
            polarAngle: 1,
            minDistance: 100,
            maxDistance: 1000,
            lookAtZ: 150,
            lookAtX: -20,
            lookAtY: 150,
            azimuthAngle: 0,
            distance: 200
        }))),
    attachComponent.withComponent(sceneEntitySelectHotspotComponent, 'select', true).withEntity('Drawstring').attach(memoEval(()=>[], ()=>({
            azimuthAngleLimits: {
                min: -1.5,
                max: 1.5
            },
            polarAngleLimits: {
                min: 0.1,
                max: 3
            },
            title: 'Drawstring cord',
            offsetZ: 150,
            offsetX: -20,
            offsetY: 160
        }))),
    attachComponent.withComponent(materialSwatchComponent, 'color', true).withEntity('Drawstring').attach(memoEval((self)=>[
            self.color,
            self.$colorSwatches
        ], (color, $colorSwatches)=>({
            selectedSwatchKey: color,
            swatches: $colorSwatches
        })), (state)=>{
        assertString(state.selectedSwatchKey);
        return {
            color: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(detailComponent, 'default', true).withEntity('Drawstring').attach(memoEval(()=>[], ()=>({
            title: 'Drawstring cord',
            subtitle: '',
            description: ''
        }))),
    attachComponent.withComponent(entityHeaderComponent, 'default', true).withEntity('Drawstring').attach(memoEval(()=>[], ()=>({})))
];

//# sourceMappingURL=drawstring.js.map